import {
	List,
	Datagrid,
	ReferenceField,
	TextField,
	DateField,
	useGetList,
	Loading,
	useUpdate,
	useRefresh,
	TopToolbar,
	CreateButton,
	ExportButton,
	FilterButton,
	Button,
	useListContext,
} from "react-admin";
import { CardContent, Typography } from "@mui/material";
import ClientNameField from "../../Fields/ClientName";
import RequestIndicator from "../../Components/RequestIndicator";
import RequestService from "../../Components/RequestService";
import RequestTimeframe from "../../Components/RequestTimeframe";
import OwnerIndicator from "../../Components/OwnerIndicator";

const defaultSort = { field: "updatedAt", order: "DESC" };

const RequestsTitle = () => {
	const hasRequests = window.location.href.includes("requests");
	return <span>{hasRequests ? "Demandes de service" : ""}</span>;
};

//Shown instead of the Datagrid when there are no rows or the query fails, which leaves no column headers to change a saved sort from
const RequestListEmpty = () => {
	const { error, setFilters, setSort } = useListContext();

	const reset = () => {
		setSort(defaultSort);
		setFilters({}, {});
	};

	return (
		<CardContent>
			<Typography variant="body2" gutterBottom>
				{error
					? "Requests could not be loaded with this sort and these filters."
					: "No requests found."}
			</Typography>
			<Button label="Reset sort and filters" onClick={reset} />
		</CardContent>
	);
};

const RequestList = (props) => {
	const refresh = useRefresh();
	const { data, isLoading, error } = useGetList("service-groups", {
		pagination: { page: 1, perPage: 100 },
	});
	const [update, { updateLoading }] = useUpdate();

	const updateRequest = (id, updateData) => {
		update(
			"requests",
			{ id, data: updateData, previousData: data },
			{ mutationMode: "pessimistic", onSuccess: () => refresh() }
		);
	};

	if (isLoading || updateLoading || !data) {
		return <Loading />;
	}
	if (error) {
		return <p>ERROR</p>;
	}

	const requestFilters = [
		<RequestService source="service" label="Service" />,
		<RequestTimeframe source="requested" label="Requested" />,
		<RequestTimeframe source="referred" label="Referred" />,
		<RequestTimeframe source="acknowledged" label="Acknowledged" />,
		<RequestTimeframe source="received" label="Completed" />,
	];

	const RequestListActions = () => (
		<TopToolbar>
			<FilterButton />
			<CreateButton />
			<ExportButton maxResults={100000} />
		</TopToolbar>
	);

	return (
		<List
			{...props}
			filters={requestFilters}
			title={<RequestsTitle />}
			perPage={25}
			sort={defaultSort}
			actions={<RequestListActions />}
		>
			<Datagrid empty={<RequestListEmpty />}>
				<DateField source="updatedAt" label="Last Updated" showTime={true} />
				<ReferenceField
					label="Service Group"
					source="service.data.id"
					reference="services"
					sortBy="serviceGroup"
				>
					<TextField source="service_group.data.attributes.name" />
				</ReferenceField>
				<ReferenceField
					label="Service"
					source="service.data.id"
					reference="services"
					sortBy="service"
				>
					<TextField source="name" />
				</ReferenceField>
				<ReferenceField
					label="Client"
					source="client.data.id"
					reference="clients"
					link="edit"
				>
					<ClientNameField source="last_name" />
				</ReferenceField>
				<RequestIndicator
					label="Requested"
					step="requested"
					updateRequest={updateRequest}
				/>
				<RequestIndicator
					label="Referred"
					step="referred"
					updateRequest={updateRequest}
				/>
				<RequestIndicator
					label="Acknowledged"
					step="acknowledged"
					updateRequest={updateRequest}
				/>
				<RequestIndicator
					label="Completed"
					step="received"
					updateRequest={updateRequest}
				/>
				<OwnerIndicator />
			</Datagrid>
		</List>
	);
};

export default RequestList;
